export default function NotFound() {
  return (
    <span>404 Not Found</span>
  );
}